import cn from 'classnames'
import { uniqueId } from 'lodash'
import React from 'react'
import { ReactComponent as CalcOfFiles } from '../../../../assets/icons/calcOfFiles.svg'
import { ReactComponent as CloseSvg } from '../../../../assets/icons/closeIcon.svg'
import FileList from '../../FileList/FileList'
import styles from '../../UserCard.module.scss'
import UserCardSmartTooltip from '../../UserCardSmartTooltip/UserCardSmartTooltip'
const VisaItem = ({ title, files, items }) => {
  const [showFileList, setShowFileList] = React.useState(false)

  return (
    <div className={styles.contentItem}>
      <div className={cn(styles.header, { [styles.visa]: true })}>
        <UserCardSmartTooltip
          id={uniqueId('visa-item-')}
          type={'simple'}
          title={title}
          titleClass={styles.contentItemTitle}
        />
        {!showFileList && (
          <div
            className={cn(styles.calcOfFilesContainer, { [styles.calcOfActive]: showFileList })}
            onClick={() => {
              files.length && setShowFileList(!showFileList)
            }}
          >
            <label className={styles.calcOfFilesContainerLabel}>Photo</label>
            <div className={styles.calcOfFiles}>
              <CalcOfFiles />
              <label className={styles.calcOfFilesLabel}>{files.length}</label>
            </div>
          </div>
        )}
        {showFileList && (
          <button
            className={styles.closeBtn}
            onClick={() => {
              files.length && setShowFileList(false)
            }}
          >
            Close
            <CloseSvg />
          </button>
        )}
      </div>

      <div className={cn(styles.body, { [styles.visa]: true })}>
        {items?.map((item, index) => (
          <UserCardSmartTooltip
            key={index}
            title={item.title}
            value={item.value}
            id={uniqueId('visa-item-')}
            containerClass={styles.item}
            titleClass={styles.itemTitle}
            valueClass={styles.itemValue}
          />
        ))}

        {files.length ? <FileList files={files} showFiles={showFileList} /> : ''}
      </div>
    </div>
  )
}

export default VisaItem
